/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from "@angular/core";
import { Router, UrlTree } from "@angular/router";
import { OrganizationFeatures } from "@vp/models";
import { FeatureService } from "@vp/shared/features";
import { Observable } from "rxjs";
import { map, take } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class ImportTagsGuardService {
  constructor(
    private featureService: FeatureService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.featureService
      .featureFlagEnabled$(OrganizationFeatures.tagManager, "enableTagImport")
      .pipe(
        take(1),
        map(enabled => (enabled ? true : this.router.createUrlTree(["/administration/tagmanager"])))
      );
  }
}
